<template>
  <van-dialog
    :value="show"
    :title="title"
    className="confirm-dialog"
    :showCancelButton="false"
    :showConfirmButton="false"
  >
    <div class="content">{{ contentText }}</div>
    <div class="btn-wrapper">
      <div class="btn cancel-btn" @click="handleCancel">{{ cancelBtnText }}</div>
      <div class="btn confirm-btn" @click="handleConfirm">{{ confirmBtnText }}</div>
    </div>
  </van-dialog>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '提示'
    },
    show: {
      type: Boolean,
      default: false
    },
    contentText: {
      type: String,
      default: ''
    },
    cancelBtnText: {
      type: String,
      default: '取消'
    },
    confirmBtnText: {
      type: String,
      default: '确认'
    }
  },
  methods: {
    handleCancel() {
      this.$emit('close')
    },
    handleConfirm() {
      this.$emit('confirm')
    }
  }
}

</script>
<style lang="less">
.confirm-dialog {
  .content {
    padding: 32px 64px;
    font-family: HarmonyOS_Sans_SC;
    font-size: 32px;
    color: #686872;
    line-height: 24px;
    box-sizing: border-box;
    text-align: center;
  }
  .btn-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 220px;
      height: 80px;
      color: #8C949D;
      background: #F0F3FC;
      border-radius: 40px;
    }
    .confirm-btn {
      margin-left: 32px;
      color: #FFFFFF;
      background: #E7166B;
    }
  }
}
</style>